import {
  DOCTORS_GET_LIST,
  DOCTORS_GET_LIST_ERROR,
  DOCTORS_GET_LIST_SUCCESS,
  DOCTOR_GET_DATA,
  DOCTOR_GET_DATA_SUCCESS,
  DOCTOR_GET_DATA_ERROR,
  DOCTOR_GET_AVATAR,
  DOCTOR_GET_AVATAR_SUCCESS,
  DOCTOR_GET_AVATAR_ERROR,
  DOCTOR_ADD_ITEM,
  DOCTOR_ADD_ITEM_SUCCESS,
  DOCTOR_ADD_ITEM_ERROR,
  DOCTOR_CLEAR_DATA,
} from "../actions";

const INIT_STATE = {
  loading: false,
  list: null,
  data: null,
  avatar: null,
  addItem: null,

  error: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    //* GET LIST OF THE DOCTORS (ACCESS ADMINS) //--------------------------------------------------------
    case DOCTORS_GET_LIST:
      return { ...state, loading: true, error: "" };

    case DOCTORS_GET_LIST_SUCCESS:
      //console.log(action.payload);
      return {
        ...state,
        loading: false,
        list: action.payload,
        error: "",
      };

    case DOCTORS_GET_LIST_ERROR:
      return { ...state, loading: false, error: action.payload };

    //* GET DATA DOCTOR  -----------------------------------------------------------------------------

    case DOCTOR_GET_DATA:
      //console.log("inside reducer");
      return { ...state, loading: true, error: "" };

    case DOCTOR_GET_DATA_SUCCESS:
      // console.log(action.payload);

      return {
        ...state,
        loading: false,
        data: action.payload,
        error: "",
      };

    case DOCTOR_GET_DATA_ERROR:
      return { ...state, loading: false, error: action.payload };

    //* GET AVATAR DOCTOR  ---------------------------------------------------------------------------
    case DOCTOR_GET_AVATAR:
      // console.log("inside reducer get avatar");
      return { ...state, loading: true, error: "" };

    case DOCTOR_GET_AVATAR_SUCCESS:
      console.log("avatar get success", action.payload);
      return {
        ...state,
        loading: false,
        avatar: action.payload,
        error: "",
      };

    case DOCTOR_GET_AVATAR_ERROR:
      return {
        ...state,
        loading: false,
        // avatar: "",
        error: action.payload,
      };

    //* ADD DOCTOR (ACCESS SUPER ADMIN OR ADMIN)// ----------------------------------------------------------------------------------------------
    case DOCTOR_ADD_ITEM:
      return { ...state, loading: true, error: "" };

    case DOCTOR_ADD_ITEM_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loading: false,
        addItem: action.payload,
        error: "",
      };

    case DOCTOR_ADD_ITEM_ERROR:
      return {
        ...state,
        loading: false,
        addItem: null,
        error: action.payload,
      };

    //* CLEAR DOCTOR DATA // ---------------------------------------------------------------------------------------------
    case DOCTOR_CLEAR_DATA:
      return {
        ...state, // repeat all the state and apply the following changes
        loading: false,
        data: null,
        addItem: null,
        editItem: null,
        removeItem: null,
      };

    default:
      return { ...state };
  }
};
